import React, { Component } from 'react'
import {connect} from 'react-redux'

class Router extends Component {



  constructor(){
    super()

    this.state={
      previousLocation:null
    }

    this.checkForLocationChange = this.checkForLocationChange.bind(this)
  }

  componentDidMount(){
    this._ismounted = true;
    this.checkForLocationChange()

  }

  requestAnimFrame(cb){
    let  anim = window.requestAnimationFrame       ||
                  window.webkitRequestAnimationFrame ||
                  window.mozRequestAnimationFrame    ||
                  function( callback ){
                    window.setTimeout(callback, 1000 / 60);
                  };


    

      ( this._ismounted === true)?
        anim(cb)
      : console.log("component not mounted, requestAnimFrame will not call");


      //onsole.log('Router');

    }


  checkForLocationChange(){

    if(this.state.previousLocation!==window.location.pathname){
      this.setState({previousLocation:window.location.pathname})

      this.props.locationChange(window.location.pathname)
    }


    //if(this.state.isMounted===true){
      this.requestAnimFrame(this.checkForLocationChange)
    //}
  }


  render() {
    return null

  }
}

const mapStateToProps =(state)=>{

  return {}
}

const mapDispatchToProps = (dispatch) => {

  return {
  locationChange:(data)=>{
    //console.log('ScrollIndex',index,max,dir)
    dispatch({type:'ROUTE_CHANGE', payload:data})
  },

}
}

export default connect(mapStateToProps,mapDispatchToProps)(Router);



// WEBPACK FOOTER //
// ./src/modules/router/Router.js